import type { ReactElement, ReactNode } from 'react';

import { useUpcomingMenu } from 'contexts/UpcomingMenu';
import UpcomingMenu from 'models/UpcomingMenu';

type Props = {
  item: UpcomingMenu;
  children?: ReactNode;
};

function PlanName({ item, children }: Props): ReactElement {
  const { dispatch } = useUpcomingMenu();

  const {
    areDetailsExpanded,
    meals_summaries: mealsSummaries,
  } = item;
  const mealSummary = mealsSummaries.reduce((acc, curr) => {
    const { count, name } = curr;
    if (count <= 0) return acc;
    // @ts-expect-error TODO: fix null safety
    const prefix = acc[acc.length - 1]?.length > 0 ? ' + ' : '';
    // @ts-expect-error TODO: fix null safety
    acc.push(`${prefix} ${count} ${name}`);
    return acc;
  }, []);

  return (
    <>
      <div>
        <span className="c-order__plan-name">
          {mealSummary}
          &nbsp;
        </span>

        <button
          className={[
            'c-link',
            'c-order__show-details-action',
            areDetailsExpanded ? '' : 'collapsed',
          ].join(' ')}
          type="button"
          onClick={() => dispatch({
            type: 'toggleDetailsExpanded',
            areDetailsExpanded: !areDetailsExpanded,
          })}
        >
          Order details
        </button>
      </div>
      {children}
    </>
  );
}

export default PlanName;
